/** eventsService */
export default {
    callbacks: {},
  
    /**
     * @param {string} eventName
     * @param {*} data
     */
    triggerEvent(eventName, data = null) {
      if (typeof this.callbacks[eventName] === "undefined") { return; }
      Object.keys(this.callbacks[eventName]).forEach((id) => {
        this.callbacks[eventName][id](data);
      });
    },
  
    /**
     * @param {string} eventName name of event
     * @param {string} id callback identifier
     * @param {Function} callback
     */
    listenEvent(eventName, id, callback) {
      if (typeof this.callbacks[eventName] === "undefined"){
        this.callbacks[eventName] = {};
      }
      this.callbacks[eventName][id] = callback;
    },
  
    /**
     * @param {string} eventName name of event
     * @param {string} id callback identifier
     */
    unlistenEvent(eventName, id) {
      if (typeof this.callbacks[eventName] === "undefined"){
        return;
      }
      delete this.callbacks[eventName][id];
    },

    get EventTypes() {
      return {
        CARD_CHANGE: 'cardChange',
        RENDER_CARD: 'renderCard',
        LOGOUT:'logout',
        LOGIN: 'login',
        NAVIGATE_TO: 'navigateto',
        SHORTCUT_SET: 'shortcutset',
        REQUEST_SYNAPSE_DATA: 'requestsettingdata',
        RESPONSE_SYNAPSE_DATA:'responsesynapsedata',
        REQUEST_SYNAPSE_TOKEN: 'requestsynapsetoken',
        RESPONSE_SYNAPSE_TOKEN: 'responsesynapsetoken',
        REQUEST_SWAP_AUDIO_STREAM: 'requestswapaudiostream',
        REQUEST_THEME: 'requestTheme',
        REQUEST_LANGUAGE: 'requestLanguage',
        RESPONSE_THEME_CHANGE: 'responseThemeChange',
        RESPONSE_LANGUAGE_CHANGE:'responseLanguageChange',
        REQUEST_ENABLE_WAKEWORD_STATUS_CHANGE: 'requestEnableWakeWordStatusChange',
        REQUEST_ENABLE_SHORTCUT_STATUS_CHANGE: 'requestEnableShortCutStatusChange',
        DEVICE_UPDATED:'deviceUpdated' ,
        ALEXA_ENABLE_CHECKED:'alexaEnableChecked',
        APP_SOUNDS_CHECKED:'appSoundsChecked',
        DISPLAY_CARDS_CHECKED: 'displayCardsChecked',
        SYNAPSE_STATUS_CHANGE: 'synapseStatusChange',
        RAZER_TOPIC_ID:'sendrazertopicid',
        SYNAPSE_ISGUEST_CHANGE: 'synapseIsGuestChange',
        ACCOUNT_LINK_CONFLICTS_NOTIFICATION:'accountLinkConflictsNotification',
        REQUEST_SHOW_ACCOUNT_LINK_CONFLICTS_DIALOG:"requestShowAccountLinkConflictsDialog",
        REQUEST_CLOSE_ACCOUNT_LINK_CONFLICTS_DIALOG:"requestCloseAccountLinkConflictsDialog",
        RESPONSE_CLOSE_ALL_DIALOG:"responseCloseAllDialog",
        RESPONSE_SHOW_LOGIN_ADDON_TEXT:"responseShowLoginAddonText",
        REQUEST_AMAZON_ID_FOR_SYNAPSE:"requestAmazonIdForSynapse",
        REQUEST_TELL_WPF_NEW_ACCESS_TOKEN:"requestTellWPFNewAccessToken",
        REQUEST_WRAPPER_IS_READY:"requestWrapperIsReady",
        WAKE_WORD_STATUS_CHANGE :"wakeWordStatusCHange",
        REQUEST_IS_ALLOW_WAKE_WORD_STATUS_CHANGE:"requestIsAllowWakeWordStatusChange",
        RESPONSE_AUDIO_DEVICE_ENABLE_STATUS:"responseAudioDeviceEnableStatus",
        DO_LOGOUT:'log',
        OPEN_FAQ:'openFaq',
        OPEN_URL:'openURL'
      }
    }
  };